export const white = "#fff";
export const grey = "#e5e5e5";
export const red = "#e74c3c";
export const green = "#27ae60";
export const blue = "#2980b9";



// WEBPACK FOOTER //
// ./src/constants/colors.js